import { render, staticRenderFns } from "./nav-links.vue?vue&type=template&id=154f8eaa"
import script from "./nav-links.ts?vue&type=script&lang=ts&external"
export * from "./nav-links.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports